"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const purple = {
    100: "#442e77",
    90: "#6131b6",
    80: "#7923ee",
    70: "#8348ef",
    60: "#8c6ce1",
    50: "#9a87db",
    40: "#aca0db",
    30: "#c0badf",
    20: "#d4d0e7",
    10: "#e6e5f0",
    0: "#f3f2fa",
};
exports.default = purple;
//# sourceMappingURL=purple.js.map